module.exports = __webpack_public_path__ + "img/k.290a4de9.jpg";